import actions from "./actions";
import {t} from "@lingui/macro";

let account;

const categories = [
    {
        category: 'assets',
        label: t`Assets`,
    },
    {
        category: 'liabilities',
        label: t`Liabilities`,
    },
    {
        category: 'equity',
        label: t`Equity`,
    },
    {
        category: 'income',
        label: t`Income`,
    }, {
        category: 'expenses',
        label: t`Expenses`,
    },
];
const types = [
    {
        id: 10,
        category: 'assets',
        type: 'current_assets',
        label: t`Current Assets`,
    }, {
        id: 15,
        category: 'assets',
        type: 'non_current_assets',
        label: t`Non-Current Assets`,
    }, {
        id: 20,
        category: 'assets',
        type: 'other_assets',
        label: t`Other Assets`,
    }, {
        id: 30,
        category: 'liabilities',
        type: 'current_liabilities',
        label: t`Current Liabilities`,
    }, {
        id: 35,
        category: 'liabilities',
        type: 'non_current_liabilities',
        label: t`Non-Current Liabilities`,
    }, {
        id: 40,
        category: 'equity',
        type: 'equity',
        label: t`Equity`,
    }, {
        id: 50,
        category: 'income',
        type: 'income',
        label: t`Income`,
    }, {
        id: 55,
        category: 'income',
        type: 'other_income',
        label: t`Other Income`,
    }, {
        id: 60,
        category: 'expenses',
        type: 'cost_of_sales',
        label: t`Cost of Sales`,
    }, {
        id: 65,
        category: 'expenses',
        type: 'expenses',
        label: t`Expenses`,
    }, {
        id: 70,
        category: 'expenses',
        type: 'taxation',
        label: t`Taxation`,
    },
];
const systemTypes = [
    {
        id: 'bank_cash',
        label: t`Bank / Cash`,
        type: 'current_assets',
    }, {
        id: 'accounts_receivable',
        label: t`Accounts Receivable`,
        type: 'current_assets',
    }, {
        id: 'inventory',
        label: t`Inventory`,
        type: 'current_assets',
    }, {
        id: 'stock_opening',
        label: t`Stock Opening`,
        type: 'cost_of_sales',
        is_locked: true,
    }, {
        id: 'stock_closing',
        label: t`Stock Closing`,
        type: 'cost_of_sales',
        is_locked: true,
    }, {
        id: 'fixed_assets',
        label: t`Fixed Assets`,
        type: 'non_current_assets',
    }, {
        id: 'accounts_payable',
        label: t`Accounts Payable`,
        type: 'current_liabilities',
    }, {
        id: 'credit_card',
        label: t`Credit Card`,
        type: 'current_liabilities',
    }, {
        id: 'my_sst_payable',
        label: t`SST Payable`,
        type: 'current_liabilities',
        is_locked: true,
    }, {
        id: 'my_sst_deferred',
        label: t`SST Deferred`,
        type: 'current_liabilities',
        is_locked: true,
    }, {
        id: 'my_epf_control',
        label: t`EPF Control`,
        type: 'current_liabilities',
        is_locked: true,
    }, {
        id: 'my_socso_control',
        label: t`SOCSO Control`,
        type: 'current_liabilities',
        is_locked: true,
    }, {
        id: 'my_eis_control',
        label: t`EIS Control`,
        type: 'current_liabilities',
        is_locked: true,
    }, {
        id: 'my_mtd_control',
        label: t`MTD Control`,
        type: 'current_liabilities',
        is_locked: true,
    }, {
        id: 'my_zakat_control',
        label: t`Zakat Control`,
        type: 'current_liabilities',
        is_locked: true,
    }, {
        id: 'my_payroll_adhoc_control',
        label: t`Payroll Adhoc Expense`,
        type: 'expenses',
        is_locked: true,
    }, {
        id: 'my_salary_control',
        label: t`Salary Control`,
        type: 'current_liabilities',
        is_locked: true,
    }, {
        id: 'goods_received_not_invoiced',
        label: t`Goods Received Not Invoiced`,
        type: 'current_liabilities',
        is_locked: true,
    }, {
        id: 'retained_earnings',
        label: t`Retained Earnings`,
        type: 'equity',
        is_locked: true,
    }, {
        id: 'discount_given',
        label: t`Discount Given`,
        type: 'income',
        is_locked: true,
    }, {
        id: 'my_sst_expense',
        label: t`SST Expense`,
        type: 'expenses',
        is_locked: true,
    }, {
        id: 'my_epf_expense',
        label: t`EPF Expense`,
        type: 'expenses',
    }, {
        id: 'my_socso_expense',
        label: t`SOCSO Expense`,
        type: 'expenses',
    }, {
        id: 'my_eis_expense',
        label: t`EIS Expense`,
        type: 'expenses',
    }, {
        id: 'my_salary_expense',
        label: t`Salary Expense`,
        type: 'expenses',
    }, {
        id: 'my_mtd_expense',
        label: t`MTD Expense`,
        type: 'expenses',
    }, {
        id: 'depreciation',
        label: t`Depreciation`,
        type: 'expenses',
    }, {
        id: 'discount_received',
        label: t`Discount Received`,
        type: 'expenses',
        is_locked: true,
    }, {
        id: 'exchange_loss',
        label: t`Exchange Loss`,
        type: 'expenses',
        is_locked: true,
    }, {
        id: 'rounding_loss',
        label: t`Rounding Loss`,
        type: 'expenses',
        is_locked: true,
    },
];

const classifications = [
    {label: t`Operating`, value: 'OPERATING'},
    {label: t`Investing`, value: 'INVESTING'},
    {label: t`Financing`, value: 'FINANCING'},
];

const initState = {
    categories,
    types,
    systemTypes,
    classifications,
    createState: null,
    createResult: {},
    readAllState: null,
    readState: null,
    updateState: null,
    archiveState: null,
    deleteState: null,
    importState: null,
    mergeState: null,
    setState: false,
    accounts: [],
    account: {
        type: null,
        parent_id: null,
        system_type: null,
        currency_code: null,
        code: null,
        name: null,
        description: null,
    },
    systemType: null,
    type: null,
    currencyCode: null,
    parentId: null,

    // table selection
    selectedAccountIds: [],
};

export default function appReducer(state = initState, action = {}) {
    switch (action.type) {
        case actions.ACCOUNT_CREATE_REQUEST:
            return {
                ...state,
                createState: 'request',
            };
        case actions.ACCOUNT_CREATE_SUCCESS:
            return {
                ...state,
                createState: 'success',
                createResult: action.account,
            };
        case actions.ACCOUNT_READ_ALL_REQUEST:
            return {
                ...state,
                readAllState: 'request',
            };
        case actions.ACCOUNT_READ_ALL_SUCCESS:
            return {
                ...state,
                readAllState: 'success',
                accounts: action.accounts,
            };
        case actions.ACCOUNT_READ_REQUEST:
            return {
                ...state,
                readState: 'request',
            };
        case actions.ACCOUNT_READ_SUCCESS:
            return {
                ...state,
                readState: 'success',
                account: action.account,
                systemType: action.account.system_type,
                type: action.account.type,
                parentId: action.account.parent_id,
                currencyCode: action.account.currency_code,
            };
        case actions.ACCOUNT_UPDATE_REQUEST:
            return {
                ...state,
                updateState: 'request',
            };
        case actions.ACCOUNT_UPDATE_SUCCESS:
            return {
                ...state,
                updateState: 'success',
            };
        case actions.ACCOUNT_ARCHIVE_REQUEST:
            return {
                ...state,
                archiveState: 'request',
            };
        case actions.ACCOUNT_ARCHIVE_SUCCESS:
            return {
                ...state,
                archiveState: 'success',
            };
        case actions.ACCOUNT_DELETE_REQUEST:
            return {
                ...state,
                deleteState: 'request',
            };
        case actions.ACCOUNT_DELETE_SUCCESS:
            return {
                ...state,
                deleteState: 'success',
            };
        case actions.ACCOUNT_IMPORT_REQUEST:
            return {
                ...state,
                importState: 'request',
            };
        case actions.ACCOUNT_IMPORT_SUCCESS:
            return {
                ...state,
                importState: 'success',
            };
        case actions.ACCOUNT_SET_ACCOUNT:
            account = {
                ...(action.reset ? initState.account : state.account),
                ...action.request,
            };

            return {
                ...state,
                account,
                systemType: account.system_type,
                type: account.type,
                parentId: account.parent_id,
                setState: true,
                currencyCode: account.currency_code,
            };
        case actions.ACCOUNT_SET_SYSTEM_TYPE:
            return {
                ...state,
                systemType: action.systemType,
            };
        case actions.ACCOUNT_SET_TYPE:
            return {
                ...state,
                type: action.typeVal,
            };
        case actions.ACCOUNT_SET_CURRENCY_CODE:
            return {
                ...state,
                currencyCode: action.currencyCode,
            };
        case actions.ACCOUNT_SET_PARENT_ID:
            return {
                ...state,
                parentId: action.parentId,
            };
        case actions.ACCOUNT_MERGE_REQUEST:
            return {
                ...state,
                mergeState: 'request',
            };
        case actions.ACCOUNT_MERGE_SUCCESS:
            return {
                ...state,
                mergeState: 'success',
            };
        case actions.ACCOUNT_MERGE_ERROR:
            return {
                ...state,
                mergeState: 'error',
            };
        case actions.ACCOUNT_SET_TABLE_IDS:
            return {
                ...state,
                selectedAccountIds: action.ids,
            };
        case actions.ACCOUNT_SET_SYSTEM_TYPES_BY_INVENTORY_SYSTEM: { // called on VALIDATE_SESSION_SUCCESS
            const isPeriodicInventory = action.inventory_system === 'periodic';

            const filteredSystemTypes = isPeriodicInventory ? systemTypes :
                systemTypes.filter(
                    item => item.id !== 'stock_opening' && item.id !== 'stock_closing');

            return {
                ...state,
                systemTypes: filteredSystemTypes,
            };
        }
        case actions.ACCOUNT_RESET:
            return {
                ...initState,
                systemTypes: state.systemTypes, // systemTypes may be filtered in ACCOUNT_SET_SYSTEM_TYPES_BY_INVENTORY_SYSTEM, so use it back
            };
        default:
            return state;
    }
}
